import { playerStorage } from 'components/widgets/Player/storages';

export function dispatchEvent(eventType: string) {
  const { player } = playerStorage.getPlayer();
  player.dispatchEvent({
    type: eventType,
  });
}
